import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Data1rorqhenzwzbc as Data } from '../GrantSlackAccessMutation.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.RESPONSE_NAMES_1 = listOf('grantSlackAccess');
      }
      fromJson_po5g3w_k$(reader, customScalarAdapters) {
        var _grantSlackAccess = null;
        $l$loop: while (true) {
          if (reader.selectName_o4466z_k$(this.RESPONSE_NAMES_1) === 0)
            _grantSlackAccess = get_NullableBooleanAdapter().fromJson_po5g3w_k$(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_grantSlackAccess);
      }
      toJson_y6n943_k$(writer, customScalarAdapters, value) {
        writer.name_i73qwh_k$('grantSlackAccess');
        get_NullableBooleanAdapter().toJson_88jnsj_k$(writer, customScalarAdapters, value.grantSlackAccess_1);
      }
      toJson_h31rt1_k$(writer, customScalarAdapters, value) {
        return this.toJson_y6n943_k$(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance23ywm38kal8s,
};
//endregion

//# sourceMappingURL=GrantSlackAccessMutation_ResponseAdapter.mjs.map
